import React from "react";
import AppModal from "../common/AppModal";
import UpdateTimetableSlotForm from "../../forms/UpdateTimetableSlotForm";
import { TimetableSlotResponseDto } from "../../shared/dtos/timetableSlot/TimetableSlotResponseDto";

interface UpdateTimetableSlotModalProps {
  open: boolean;
  onClose: () => void;
  slot: TimetableSlotResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdateTimetableSlotModal: React.FC<UpdateTimetableSlotModalProps> = ({
  open,
  onClose,
  slot,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Edit Timetable Slot"
    width="sm"
    loading={loading}
  >
    <UpdateTimetableSlotForm slot={slot} loading={loading} error={error} />
  </AppModal>
);

export default UpdateTimetableSlotModal;
